import React from "react";

const Reset = () => {
  return <div>Reset</div>;
};

export default Reset;
